import React from 'react';
import PropTypes from 'prop-types';
import { nSamplesInGroups } from '../utils';
import ReceivedSamples from './ReceivedSamples';

const stylesTable = {
  borderCollapse: 'collapse',
  borderSpacing: 0
};

function SamplesReceivedTable(props) {
  const nSamples = nSamplesInGroups(props.sampleGroups);
  return (
    <table className="queueT" style={stylesTable}>
      <tbody>
        <tr>
          <th colSpan={7}>
            <span style={{ color: 'red' }}>Samples Received</span> ({nSamples})
          </th>
        </tr>
        <tr>
          <th></th>
          <th>Target</th>
          <th>#</th>
        </tr>
        <ReceivedSamples sampleGroups={props.sampleGroups} />
      </tbody>
    </table>
  );
}

SamplesReceivedTable.propTypes = {
  sampleGroups: PropTypes.array.isRequired
};

export default SamplesReceivedTable;
